var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormulationexperience4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_95_649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.8004 21.6L37.5004 13.4L14.9004 29.8L23.5004 56.4H51.5004L60.1004 29.8L48.8004 21.6ZM37.8004 12.2C45.7004 17.9 53.6004 23.7 61.5004 29.4C58.4004 38.8 55.4004 48.2 52.3004 57.6H22.6004C19.5004 48.2 16.5004 38.8 13.4004 29.4L37.4004 12L37.8004 12.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4 8C42 8 45.8 11.8 45.8 16.4C45.8 21 42 24.8 37.4 24.8C32.8 24.8 29 21 29 16.4C29 11.8 32.8 8 37.4 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9996 22.1C22.5996 22.1 26.3996 25.9 26.3996 30.5C26.3996 35.1 22.5996 38.9 17.9996 38.9C13.3996 38.9 9.59961 35.1 9.59961 30.5C9.59961 25.9 13.3996 22.1 17.9996 22.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.8004 22.1C61.4004 22.1 65.2004 25.9 65.2004 30.5C65.2004 35.1 61.4004 38.9 56.8004 38.9C52.2004 38.9 48.4004 35.1 48.4004 30.5C48.4004 25.9 52.2004 22.1 56.8004 22.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4 44.9C30 44.9 33.8 48.7 33.8 53.3C33.8 57.9 30 61.7 25.4 61.7C20.8 61.7 17 57.9 17 53.3C17 48.7 20.8 44.9 25.4 44.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4 44.9C54 44.9 57.8 48.7 57.8 53.3C57.8 57.9 54 61.7 49.4 61.7C44.8 61.7 41 57.9 41 53.3C41 48.7 44.8 44.9 49.4 44.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7002 36.2C30.7002 37.5 30.7002 38.3 31.3002 39.4C32.0002 40.7 32.9002 41.7 34.3002 42.4C35.0002 42.8 35.8002 43 36.6002 43H37.5002C38.7002 42.9 39.9002 42.5 40.9002 41.7C42.8002 40.2 43.9002 37.8 43.4002 35.1C43.3002 34.5 43.0002 34 43.0002 33.9C42.7002 34 42.3002 34.7 41.8002 34.9C42.3002 35.9 42.1002 37.7 41.6002 38.7C41.3002 39.3 41.0002 39.7 40.6002 40.1C37.5002 43.2 32.0002 41 32.0002 36.5C32.0002 32.9 35.8002 30.1 39.6002 32.2L40.7002 31.2C39.5002 30.5 38.7002 30.1 37.1002 30.1C35.2002 30.1 33.6002 30.9 32.7002 31.9C32.6002 32 32.5002 32.1 32.3002 32.3C31.5002 33.1 30.7002 34.9 30.7002 36.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2002 36.3L35.2002 34.3L34.2002 35.3L37.2002 38.3C37.5002 38.1 37.8002 37.7 38.1002 37.4L38.5002 37C38.6002 36.9 38.8002 36.7 38.9002 36.6C39.0002 36.6 39.0002 36.5 39.0002 36.5L41.3002 34.2C41.5002 34 41.6002 33.9 41.9002 33.5L43.4002 32C43.5002 31.9 43.5002 31.8 43.6002 31.7C43.8002 31.5 43.9002 31.4 44.0002 31.2L43.0002 30.2C42.8002 30.3 42.7002 30.4 42.6002 30.6L41.5002 31.7C41.0002 32.2 39.6002 33.5 39.3002 33.9L37.8002 35.4C37.7002 35.5 37.6002 35.6 37.4002 35.8L37.2002 36.3Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_95_649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74.1,
    height: 74.1,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormulationexperience4);
export default __webpack_public_path__ + "static/media/formulationexperience4.5efe95d2522e0da0fa1ff4030f661905.svg";
export { ForwardRef as ReactComponent };